import { Col, Container, Row, Spinner } from 'react-bootstrap';
import * as TYPES from './types'

const LoadingComponent: React.FC<TYPES.LoadingComponentProps> = (props: TYPES.LoadingComponentProps) => {
    switch(props.type || ''){
        case 'pulse-dot': {
            return (
                <span className={`gn-pulse-dot${props.variant === 'danger' ? ' gn-pulse-dot--danger' : ''}`} />
            );
        }
        case 'flex-centered': {
            return(
                <div className="d-flex justify-content-center align-items-center">
                    <Spinner size={props.size || undefined} animation="border" variant={props.variant || "orange"} />
                </div>
            );
        }
        case 'container-centered': {
            return(
                <Container fluid>
                    <Row>
                        <Col className="text-center">
                            <Spinner size={props.size || undefined} animation="border" variant={props.variant || "orange"} />
                        </Col>
                    </Row>
                </Container>
            );
        }
        default: {
            return (<Spinner size={props.size || undefined} animation="border" variant={props.variant || "orange"} />);
        }
    }
}

export default LoadingComponent;